export default {"src":"/_next/static/media/clipboardWithWave_24.129e8b23.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};